// extracted by mini-css-extract-plugin
export default {"container":"Tile-module__container__twq7k","selected":"Tile-module__selected__6yB61","label":"Tile-module__label__If3sv"};